module.exports = __webpack_public_path__ + "img/arrow-down.9afa74b2.svg";